import type { ProductReviews } from "./types";
import type { YotpoResponse } from "./yotpo/types";

export function normalizeProductReviews(data: YotpoResponse): ProductReviews | null {
    if (!data) {
        return null;
    }

    return {
        averageScore: data?.bottomline?.average_score || 0,
        totalScore: data?.bottomline?.total_review || 0,
        userReviews:
            data?.reviews?.map((review) => ({
                displayName: review.user.display_name,
                createdAt: review.created_at,
                content: review.content,
                score: review.score,
            })) || [],
    };
}
